module.exports = __webpack_public_path__ + "img/banner2.c03a3816.jpg";